export const capitalizeFirstLetter = (item: string) => {
  return item ? item.charAt(0).toUpperCase() + item.slice(1) : '';
};

export const checkIfEmptyObject = (item: any) => {
  const itemToCheck = !!item ? item : {};

  function isEmpty(object: object) {
    return Object.keys(object).length === 0;
  }

  return isEmpty(itemToCheck);
}


